<h1 mat-dialog-title>Are you sure you want to delete?</h1>
<div mat-dialog-actions>
    <button class="cancel-button" mat-button [mat-dialog-close]>Cancel</button>
    <button class="delete-button" mat-button [mat-dialog-close]="true">Delete</button>
</div>
